// @react/hooks/useAffiliateOffer.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { affiliateOfferStore } from '@core/stores';

/**
 * React hook for Offer operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useAffiliateOffer } from '@react/hooks';
 *
 * const OfferList = observer(() => {
 *   const store = useAffiliateOffer();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useAffiliateOffer() {
  return affiliateOfferStore;
}
